import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { sessionsApi, userFilesApi } from 'api';
import { usePanel } from 'contexts/panelContext';
import { Loader } from 'components/_new/Loader';
import { UploadUserFiles } from 'components/session/yourNotes/UploadUserFiles';
import { ErrorContainer } from 'components/_new/ErrorContainer/ErrorContainer';
import { SessionFile } from 'types/SessionFile';

export const SessionAgendaAddNote = () => {
	const { pairId, sessionId, userFileId } = useParams();
	const { t } = useTranslation();

	// const [afterAdd, setAfterAdd] = useState(false);
	const [selectedUserfile, setSelectedUserfile] = useState<SessionFile | undefined>(undefined);
	const { userPairsLoading, currentProgramMembership } = usePanel();

	const { data: sessionsData, isLoading: sessionsLoading } = useQuery(
		['sessions', { pairId: Number(pairId) }],
		() => sessionsApi.getSessions(Number(pairId), currentProgramMembership.id),
		{ enabled: Boolean(currentProgramMembership) }
	);
	const currentSession = sessionsData?.find((session) => session.id === Number(sessionId));

	const [hasChanges, setHasChanges] = useState(false);
	useEffect(() => {
		const handleBeforeUnload = (e: BeforeUnloadEvent) => {
			if (hasChanges) {
				e.preventDefault();
				e.returnValue = '';
			}
		};

		window.addEventListener('beforeunload', handleBeforeUnload);

		return () => {
			window.removeEventListener('beforeunload', handleBeforeUnload);
		};
	}, [hasChanges]);

	const { isLoading: usefileLoading, refetch: userfileRefetch } = useQuery(
		['userfile', { userFileId }],
		() => userFilesApi.getUserfile(Number(userFileId)),
		{
			onSuccess: (data) => {
				setSelectedUserfile(data.userFile);
			},
			enabled: Boolean(userFileId),
		}
	);

	const handleFinish = useCallback(() => {
		userfileRefetch();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const handleSave = () => setHasChanges(false);

	if (userPairsLoading || sessionsLoading || (userFileId && usefileLoading)) {
		return <Loader />;
	}

	if (!currentSession) {
		return <ErrorContainer />;
	}

	return (
		<div className="container p-4">
			<UploadUserFiles
				userFile={selectedUserfile}
				setUserFile={setSelectedUserfile}
				setHasChanges={setHasChanges}
				session={currentSession}
				onFinish={handleFinish}
				onSave={handleSave}
			/>
		</div>
	);
};
